import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getServices, StateStatus } from '@guryou/redux';
const useService = _ref => {
  let {
    serviceId,
    type
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(state => state.services.all);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getServices(type));
    }
  }, [dispatch, status, type]);
  return {
    service: (data || []).find(x => x.id === +serviceId),
    status,
    version,
    entity
  };
};
export default useService;